import { Action } from 'redux';

export const GET_DRIVER_ATTRIBUTES = 'driver-attribute/GET_DRIVER_ATTRIBUTES';
export const PERSIST_DRIVER_ATTRIBUTES = 'driver-attribute/PERSIST_DRIVER_ATTRIBUTES';

export const GET_DRIVER_ATTRIBUTE = 'driver-attribute/GET_DRIVER_ATTRIBUTE';
export const PERSIST_DRIVER_ATTRIBUTE = 'driver-attribute/PERSIST_DRIVER_ATTRIBUTE';

export const CREATE_DRIVER_ATTRIBUTE = 'driver-attribute/CREATE_DRIVER_ATTRIBUTE';
export const UPDATE_DRIVER_ATTRIBUTE = 'driver-attribute/UPDATE_DRIVER_ATTRIBUTE';
export const DELETE_DRIVER_ATTRIBUTE = 'driver-attribute/DELETE_DRIVER_ATTRIBUTE';
export const BULK_UPDATE_DRIVER_ATTRIBUTE = 'driver-attribute/BULK_UPDATE_DRIVER_ATTRIBUTE';

// Property only
export const UPDATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE = 'driver-attribute/UPDATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE';
export const CREATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE = 'driver-attribute/CREATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE';
export const DELETE_DRIVER_ATTRIBUTE_PROPERTY_VALUE = 'driver-attribute/DELETE_DRIVER_ATTRIBUTE_PROPERTY_VALUE';

export interface GetDriverAttributeAction extends Action<typeof GET_DRIVER_ATTRIBUTE> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly id: number;
  };
}
export const getDriverAttribute = (id: number, meta: ActionMetaData = {}): GetDriverAttributeAction => ({
  meta,
  payload: {
    id,
  },
  type: GET_DRIVER_ATTRIBUTE,
});

export interface PersistDriverAttributeAction extends Action<typeof PERSIST_DRIVER_ATTRIBUTE> {
  readonly payload: {
    readonly attribute: DriverAttribute;
  };
}

export const persistDriverAttribute = (attribute: DriverAttribute) => ({
  payload: {
    attribute,
  },
  type: PERSIST_DRIVER_ATTRIBUTE,
});

export interface GetDriverAttributesAction extends Action<typeof GET_DRIVER_ATTRIBUTES>, OnCompleteAction {}

export const getDriverAttributes = (onComplete?: () => void): GetDriverAttributesAction => ({
  meta: {
    onComplete,
  },
  type: GET_DRIVER_ATTRIBUTES,
});

export interface PersistDriverAttributesAction extends Action<typeof PERSIST_DRIVER_ATTRIBUTES> {
  readonly payload: {
    readonly attributes: ReadonlyArray<DriverAttribute>;
  };
}

export const persistDriverAttributes = (attributes: ReadonlyArray<DriverAttribute>): PersistDriverAttributesAction => ({
  payload: {
    attributes,
  },
  type: PERSIST_DRIVER_ATTRIBUTES,
});

export interface CreateDriverAttributeAction extends Action<typeof CREATE_DRIVER_ATTRIBUTE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttributePayload;
  };
}

export const createDriverAttribute = (
  attribute: DriverAttributePayload,
  onComplete?: () => void,
): CreateDriverAttributeAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
  },
  type: CREATE_DRIVER_ATTRIBUTE,
});

export interface UpdateDriverAttributeAction extends Action<typeof UPDATE_DRIVER_ATTRIBUTE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttributePayload;
  };
}

export const updateDriverAttribute = (
  attribute: DriverAttributePayload,
  onComplete?: () => void,
): UpdateDriverAttributeAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
  },
  type: UPDATE_DRIVER_ATTRIBUTE,
});

export interface DeleteDriverAttributeAction extends Action<typeof DELETE_DRIVER_ATTRIBUTE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttribute;
  };
}

export const deleteDriverAttribute = (
  attribute: DriverAttribute,
  onComplete?: () => void,
): DeleteDriverAttributeAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
  },
  type: DELETE_DRIVER_ATTRIBUTE,
});

export interface UpdateDriverAttributePropertyValueAction
  extends Action<typeof UPDATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttribute;
    readonly value: DriverAttributePropertyValuePayload;
  };
}

export const updateDriverAttributePropertyValue = (
  attribute: DriverAttribute,
  value: DriverAttributePropertyValuePayload,
  onComplete?: () => void,
): UpdateDriverAttributePropertyValueAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
    value,
  },
  type: UPDATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE,
});

export interface CreateDriverAttributePropertyValueAction
  extends Action<typeof CREATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttribute;
    readonly value: DriverAttributePropertyValuePayload;
  };
}

export const createDriverAttributePropertyValue = (
  attribute: DriverAttribute,
  value: DriverAttributePropertyValuePayload,
  onComplete?: () => void,
): CreateDriverAttributePropertyValueAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
    value,
  },
  type: CREATE_DRIVER_ATTRIBUTE_PROPERTY_VALUE,
});

export interface DeleteDriverAttributePropertyValueAction
  extends Action<typeof DELETE_DRIVER_ATTRIBUTE_PROPERTY_VALUE>, OnCompleteAction {
  readonly payload: {
    readonly attribute: DriverAttribute;
    readonly value: DriverAttributePropertyValue;
  };
}

export const deleteDriverAttributePropertyValue = (
  attribute: DriverAttribute,
  value: DriverAttributePropertyValue,
  onComplete?: () => void,
): DeleteDriverAttributePropertyValueAction => ({
  meta: {
    onComplete,
  },
  payload: {
    attribute,
    value,
  },
  type: DELETE_DRIVER_ATTRIBUTE_PROPERTY_VALUE,
});

export interface BulkUpdateDriverAttributeAction extends Action<typeof BULK_UPDATE_DRIVER_ATTRIBUTE> {
  readonly payload: {
    readonly attributeId: number;
    readonly oldValue: number;
    readonly newValue: number;
  };
}

export const bulkUpdateDriverAttribute = (
  attributeId: number,
  oldValue: number,
  newValue: number,
): BulkUpdateDriverAttributeAction => ({
  type: BULK_UPDATE_DRIVER_ATTRIBUTE,
  payload: {
    attributeId,
    oldValue,
    newValue,
  },
});

export type DriverAttributeAction =
  | CreateDriverAttributeAction
  | DeleteDriverAttributeAction
  | GetDriverAttributesAction
  | PersistDriverAttributesAction
  | GetDriverAttributeAction
  | PersistDriverAttributeAction
  | UpdateDriverAttributeAction;
